import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/index.css";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import SiteSchema from "@/components/SiteSchema";

import Home from "@/pages/Home";
import Vehicles from "@/pages/Vehicles";
import VehicleDetail from "@/pages/VehicleDetail";
import Booking from "@/pages/Booking";
import BookingConfirmed from "@/pages/BookingConfirmed";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Messages from "@/pages/Messages";
import Admin from "@/pages/Admin";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Terms from "@/pages/Terms";
import Insurance from "@/pages/Insurance";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import { ADMIN_PATH } from "@/lib/routes";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Google Auth callback before regular routing
  if (typeof window !== "undefined" && location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <SiteSchema />
      <ScrollToTop />
      <Navbar />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vehicles" element={<Vehicles />} />
          <Route path="/vehicles/:slug" element={<VehicleDetail />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/booking/:id/confirmed" element={<BookingConfirmed />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/messages" element={<Messages />} />
          <Route path={ADMIN_PATH} element={<Admin />} />
          {/* Legacy /admin route is intentionally NOT registered — attackers hitting it get the 404. */}
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/insurance-requirements" element={<Insurance />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/guides/:slug" element={<GuideDetail />} />
          <Route path="*" element={<div className="container-bl py-24 text-center text-[#AEB9C9]">Page not found.</div>} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
